import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    max-width: 969px;
    overflow: auto;
    display: flex;
    background-color: #fff;
    flex-direction: column;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    .input-valor {
        margin: 0 32px;
        margin-bottom: -32px;
    }

    .options  {
                margin-left: 32px;
                width: 90%;
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                align-items: center;
                flex-direction: row;

                @media (max-width: 600px) {
                    margin-left: 16px;
                }

                .option {
                    cursor: pointer;
                    margin-right: 16px;
                    margin-bottom: 16px;
                    border: 2.5px solid #2a0709;
                    border-radius: 100px;
                    padding: 12px 32px;

                    @media(max-width: 784px) {
                        padding: 12px 24px;
                    }

                    span {
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 700;
                        color: #2a0709;

                        @media(max-width: 784px) {
                            font-size: 16px;
                        }
                    }
                }

                .option-selected {
                    cursor: pointer;
                    margin-right: 16px;
                    margin-bottom: 16px;
                    background-color: #2a0709;
                    border: 2.5px solid #2a0709;
                    border-radius: 100px;
                    padding: 12px 32px;

                    @media(max-width: 784px) {
                        padding: 12px 24px;
                    }

                    span {
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 700;
                        color: #fff;

                        @media(max-width: 784px) {
                            font-size: 16px;
                        }
                    }
                }
            }

    .div-input {
        position: relative;
        max-width: 511px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid lightgray;
        margin-bottom: 40px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 360px) {
            height: 64px;
        }
    }

    .div-input-disabled {
        position: relative;
        max-width: 511px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid lightgray;
        margin-bottom: 40px;
        padding: 0;
        box-sizing: border-box;
        background-color: #faf8f9;

        @media(max-width: 360px) {
            height: 64px;
        }
    }

    .div-input-focado {
        position: relative;
        max-width: 511px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #1c0506;
        margin-bottom: 40px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 360px) {
            height: 64px;
        }
    }

    .div-input-error {
        position: relative;
        max-width: 511px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #c32027;
        margin-bottom: 8px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 360px) {
            height: 64px;
        }
    }

    .div-input input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        :disabled {
            cursor: not-allowed;
            background: #faf8f9;
            width: 100%;
        }

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-disabled input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        :disabled {
            cursor: not-allowed;
            background: #faf8f9;
            width: 100%;
        }

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-focado input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-error input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #c42027;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-disabled label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-focado label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-error label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-disabled label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-focado label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-error label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .content-name {
        position: absolute;
        bottom: 8px;
        left: 0px;
        transition: all 0.3s ease;
    }

    .div-input input:focus + .label-name .content-name,
    .div-input input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input::after {
            border: none;
        }
    }

    .div-input-disabled input:focus + .label-name .content-name,
    .div-input-disabled input:valid + .label-name .content-name,
    .div-input-disabled input:disabled + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input::after {
            border: none;
        }
    }

    .div-input-focado input:focus + .label-name .content-name,
    .div-input-focado input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-focado::after {
            border: none;
        }
    }

    .div-input-error input:focus + .label-name .content-name,
    .div-input-error input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-error::after {
            border: none;
        }
    }

    .div-input input:focus + .label-name::after,
    .div-input input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-disabled input:focus + .label-name::after,
    .div-input-disabled input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-focado input:focus + .label-name::after,
    .div-input-focado input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-error input:focus + .label-name::after,
    .div-input-error input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-disabled button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-focado button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-error button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .close {
        position: absolute;
        right: 32px;
        top: 32px;

        @media(max-width: 600px) {
                right: 10px;
                top: 10px;
            }
        
        button {
            background-color: transparent;
            outline: none;
            cursor: pointer;
            border: none;
            align-self: center;
            box-sizing: border-box;

            .i-close {
                vertical-align: middle;
                align-self: center;
                font-size: 36px;
                top: 10px;
                bottom: 10px;
                left: 10px;
                right: 10px;
                color: #c0b7b8 !important;

                @media(max-width: 600px) {
                    font-size: 26px;
                    top: 16px;
                    bottom: 16px;
                    left: 16px;
                    right: 16px;
                }
            }
        }
    }

    .header {
        display: flex;
        flex-direction: column;
        max-width: 560px;
        padding-left: 32px;
        padding-top: 80px;
        padding-bottom: 40px;

        @media (max-width: 420px) {
            padding-left: 16px;
            max-width: 291px;
        }

        @media (max-width: 600px) {
            padding-left: 16px;
            max-width: 400px;
        }

        @media (max-width: 784px) {
            padding-top: 96px;
        }

            img {
                width: 32px;
                height: 32px;
                margin: 0px;
                padding: 0px;
                object-fit: contain;
            }

            h1 {
                font-family: Montserrat;
                font-size: 32px;
                margin: 0px;
                padding: 0px;
                font-weight: 700;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.5;
                letter-spacing: normal;
                text-align: left;
                color: #000000;

                @media(max-width: 420px) {
                        font-size: 24px;
                    }
            }
    }

        .entrada-saida {
            padding-left: 8px;
            display: flex; 
            flex-direction: row;

            @media (max-width: 600px) {
                flex-direction: column;
                padding-left: 16px;
                padding-right: 16px;
            }

            .horario {
                margin-left: 24px;
                position: relative;
                display: flex; 
                flex-direction: column;
                list-style: none;

                @media (max-width: 600px) {
                    margin-left: 0;
                    width: 100%;
                }

                .turno-aberto{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    cursor: pointer;
                    width: 204px;
                    height: 88px;
                    border: 1.5px solid #ececec;
                    background-color: #fff;
                    border-radius: 10px;

                    @media (max-width: 600px) {
                        width: 100%;
                        margin-right: 32px;
                        margin-bottom: 16px;
                    }

                    .left {
                        padding-left: 24px;
                    }

                    .chevron {
                        padding-right: 24px;
                    }

                    h4 {
                        margin: 0;
                        padding: 0;
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 600;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1;
                        letter-spacing: normal;
                        text-align: left;
                        color: #2a0709;
                    }
                    h5 {
                        margin: 0;
                        margin-bottom: 12px;
                        padding: 0;
                        font-family: Montserrat;
                        font-size: 12px;
                        font-weight: 600;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1;
                        letter-spacing: normal;
                        text-align: left;
                        color: #a49a9b;
                    }
                }
            }
        }

        .botao {
            display: flex;
            padding-left: 32px;
            padding-top: 56px;
            padding-bottom: 64px;

            @media(max-width: 600px) {
                    padding-top: 24px;
                    padding-left: 16px;
                }

            .salvar {
                cursor: pointer;
                height: 40px;
                width: 160px;
                background-color: #c32027;
                outline: none;
                border: none;
                border-radius: 20px;
                justify-content: center;
                align-items: center;
                color: #fff;
                font-family: Montserrat;
                font-size: 11px;
                font-weight: 600;
                transition: 0.2s;

                :hover {
                    background-color: #9c1a1f
                }

                :active {
                    background-color: #d7232c
                }

                @media(max-width: 600px) {
                    width: 100%;
                    margin-right: 16px;
                }
            }
        }

`